<script setup lang="ts">
// COMPOSABLES
const { tt, tn } = useTypedI18n();
const { busAssets } = useFleequidStats();
const { phones } = useFleequidContacts();

// DATA
const mainPhone = computed(() => phones.value[0]);
const vehiclesInspected = computed(() => tt('announcementBar.vehiclesInspected', { count: tn(busAssets.value, 'integer') }));
</script>

<template>
    <div class="bg-primary sticky inset-x-0 top-0 z-40 flex h-(--announcement-bar-height) items-center text-xs font-medium text-white">
        <!-- Desktop -->
        <BaseWidthContainer class="hidden w-full items-center justify-between lg:flex">
            <div class="flex items-center gap-3">
                <span>{{ vehiclesInspected }}</span>
                <span class="text-white/50">·</span>
                <span>{{ tt('announcementBar.securePayments') }}</span>
                <span class="text-white/50">·</span>
                <span>{{ tt('announcementBar.warranty') }}</span>
            </div>
            <span v-if="mainPhone" class="inline-flex gap-1">
                {{ tt('announcementBar.callForAdvice') }}
                <BasePhoneLink class="text-white" :phone="mainPhone" />
            </span>
        </BaseWidthContainer>

        <!-- Mobile: marquee -->
        <UMarquee :overlay="false" class="lg:hidden" :ui="{ root: '[--gap:--spacing(4)]' }">
            <span>{{ vehiclesInspected }}</span>
            <span class="text-white/50">·</span>
            <span>{{ tt('announcementBar.securePayments') }}</span>
            <span class="text-white/50">·</span>
            <span>{{ tt('announcementBar.warranty') }}</span>
            <span class="text-white/50">·</span>
            <span v-if="mainPhone" class="inline-flex gap-1">
                {{ tt('announcementBar.callForAdvice') }}
                <BasePhoneLink class="text-white" :phone="mainPhone" />
            </span>
            <span class="text-white/50">·</span>
        </UMarquee>
    </div>
</template>
